import React from 'react'
import PropTypes from 'prop-types'
import { FormControlLabel, Checkbox, FormGroup } from '../mui/Core/index'

function LabeledCheckbox({ checked, label, onChange }) {
  return (
    <FormGroup>
      <FormControlLabel
        sx={{
          alignItems: 'center',
          '& .MuiFormControlLabel-label': {
            fontSize: '16px',
            fontFamily: 'AtlasGroteskRegular',
          },
        }}
        control={<Checkbox checked={checked} onChange={onChange} />}
        label={label}
      />
    </FormGroup>
  )
}

export default LabeledCheckbox

LabeledCheckbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}
